export default "__VITE_ASSET__BlwDL2Bt__"